var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "heart-ico-small",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.408,
    height: 18.394,
    viewBox: "0 0 19.408 18.394",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_208",
    "data-name": "Rectangle 208",
    width: 19.408,
    height: 18.394,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_319",
    "data-name": "Groupe 319",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1096",
    "data-name": "Trac\\xE9 1096",
    d: "M15.033.235c-.163,0-.329.007-.492.022a5.893,5.893,0,0,0-4.33,2.88A6.924,6.924,0,0,0,4.717,0,5.154,5.154,0,0,0,3.385.174,4.514,4.514,0,0,0,.4,2.9a5.35,5.35,0,0,0,.28,4.655c1.092,1.852,2.965,2.983,4.776,4.076a24.616,24.616,0,0,1,2.717,1.807,8.241,8.241,0,0,1,.819.737,11.185,11.185,0,0,0-1,1.437,3.024,3.024,0,0,0-.245,2.051,1.072,1.072,0,0,0,.566.635,1.017,1.017,0,0,0,.433.1,2.386,2.386,0,0,0,1.617-1.114,2.6,2.6,0,0,0,.313-2.9c.851-.77,1.777-1.486,2.673-2.178a26.229,26.229,0,0,0,4.4-3.972c.619-.757,2.535-3.418,1.181-5.9a4.3,4.3,0,0,0-3.9-2.093m-5.54,16.01a1.758,1.758,0,0,1-.394.537,2.858,2.858,0,0,1,.256-.918c.025-.055.19-.309.308-.48a1.423,1.423,0,0,1-.17.861m-1.54-13.7A6.153,6.153,0,0,1,9,3.644c.035.048.089.138.152.242.362.6.751,1.192,1.172,1.192.209,0,.386-.147.526-.437a5.014,5.014,0,0,1,4.014-3.106c.1-.009.2-.013.3-.013A2.964,2.964,0,0,1,17.994,3.41c.528,1.489-.308,3.254-2.555,5.394A38.781,38.781,0,0,1,12.37,11.35c-.812.627-1.651,1.276-2.437,1.966a12.607,12.607,0,0,0-2.368-1.927c-.436-.29-.908-.573-1.407-.873C3.7,9.041.922,7.369,1.361,4.256a3.264,3.264,0,0,1,3.375-2.93c.132,0,.268.006.4.019a5.285,5.285,0,0,1,2.815,1.2",
    transform: "translate(0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIcon);
export default __webpack_public_path__ + "static/media/heart-icon.17f44c4712bd038d9cdead591ba3a28c.svg";
export { ForwardRef as ReactComponent };